import { ref } from 'vue'

const STORAGE_KEY = 'cg:recent-searches'
const LIMIT = 5

function read () {
    try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]')
        return Array.isArray(value) ? value.filter(item => typeof item === 'string').slice(0, LIMIT) : []
    } catch {
        return []
    }
}

function write (items) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
    } catch {
        // Storage can be full or blocked (private mode); remembering searches is a nice-to-have
    }
}

// Shared between the search bars on a page (header and homepage hero)
const recent = ref(read())

/**
 * The last few search queries of this visitor, newest first. Only stored in their own browser.
 */
export function useRecentSearches () {
    function remember (query) {
        const value = query.trim()
        if (!value) return

        recent.value = [value, ...recent.value.filter(item => item.toLowerCase() !== value.toLowerCase())].slice(0, LIMIT)
        write(recent.value)
    }

    function clear () {
        recent.value = []
        write([])
    }

    return { recent, remember, clear }
}
